module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionSlotTemplateDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.missionSlotTemplateDetails.title))]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.by')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionSlotTemplateDetails.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionSlotTemplateDetails.creator)))])], 1), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.visibility')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionSlotTemplateVisibility)
    }
  })])]), _vm._v(" "), (_vm.loggedIn) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [(_vm.isMissionSlotTemplateCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateEditModal",
      modifiers: {
        "missionSlotTemplateEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.loggedIn) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionSlotTemplateDuplicateModal",
      modifiers: {
        "missionSlotTemplateDuplicateModal": true
      }
    }],
    attrs: {
      "variant": "secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission.slotTemplate')) + "\n        ")]) : _vm._e(), _vm._v(" \n        "), (_vm.isMissionSlotTemplateCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.slotTemplate.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMissionSlotTemplate
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('mission.slotTemplate.slotlist')))]), _vm._v(" "), _c('mission-slot-template-slotlist')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loggedIn) ? _c('mission-slot-template-duplicate-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-edit-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-create-modal') : _vm._e(), _vm._v(" "), _c('mission-slot-template-slot-details-modal'), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-edit-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-group-create-modal') : _vm._e(), _vm._v(" "), (_vm.isMissionSlotTemplateCreator) ? _c('mission-slot-template-slot-group-edit-modal') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f5c8574"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionSlotTemplateDetails.vue
// module id = 473
// module chunks = 0